<template>
  <ModalComponent
      :name="'editarNombre-' + ticket.id"
      title="Modificar nombre de entrada"
      v-on:close="() => close(false)"
  >
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
      <div class="row">
        <div class="col-12">
          <p>Introduce los nuevos datos:</p>
          <FormInput label="Nuevo nombre" name="nombre" id="editar-nombre" rules="required" v-model="name" />
          <FormInput label="Nuevos apellidos" name="apellidos" id="editar-apellidos" rules="required" v-model="apellidos" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button type="submit" name="button" class="btn btn-danger" id="btn-submit-changes">Cambiar</button>
        </div>
      </div>
    </ValidationObserver>
  </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['ticket', 'sesion_id', 'evento_id'],
    data() {
        return {
            name: null,
            apellidos: null,
        }
    },
    methods: {
        close() {
            this.name = null
            this.apellidos = null
            this.$emit('close', 'editarNombre-' + this.ticket.id);
        },
        async submit() {

            const data = {
                sesion_id : this.sesion_id,
                evento_id : this.evento_id,
                entrada_id : this.ticket.id,
                nombre : this.name,
                apellidos : this.apellidos
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.entradas.editar.nombre'), data)
                .then(res => {
                    this.$toast.success(res.data.message);

                    this.ticket.nombre = this.name + ' ' + this.apellidos;
                    this.ticket.apellidos = this.apellidos;

                    this.close();
                });
        }
    },
    components: {
        ModalComponent
    }
}
</script>
